import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-taxonomy-home',
  templateUrl: './taxonomy-home.component.html',
  styleUrls: ['./taxonomy-home.component.css']
})
export class TaxonomyHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
